module.exports = __webpack_public_path__ + "static/media/ststephen.a415c662.webp";